import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl, ReactiveFormsModule } from '@angular/forms';
import { RxState } from '@rx-angular/state';
import { PushPipe } from '@rx-angular/template/push';
import { map } from 'rxjs/operators';

import { BaseFormControlElement } from '@core/base/base-form-control-element';
import { Identity } from '@core/interfaces/util/identity.interface';
import { LookupService } from '@core/services/lookup.service';
import {
  FormSelectNewComponent,
} from '@shared/form/form-select-new/form-select-new.component';
import { PipesModule } from '@shared/pipes/pipes.module';

interface IContactTimeSelectState {
  selectedItem: Identity;
}

@Component({
  selector: 'app-contact-time-select-new',
  standalone: true,
  templateUrl: './contact-time-select-new.component.html',
  styleUrls: ['./contact-time-select-new.component.scss'],
  providers: [RxState],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormSelectNewComponent,
    ReactiveFormsModule,
    PushPipe,
    PipesModule,
    NgIf,
  ],
})
export class ContactTimeSelectNewComponent extends BaseFormControlElement implements OnInit {
  @Input() readonly = false;

  itemsList$ = this.lookupService.getLookup('contacttime');
  selectedItemName$ = this.state.select('selectedItem', 'name');

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private readonly lookupService: LookupService,
    private readonly state: RxState<IContactTimeSelectState>,
  ) {
    super(ngControl);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.state.connect(
      'selectedItem',
      this.itemsList$.pipe(map(items => items.find(item => item.id === this.formControl.value))),
    );
  }
}
